export default "/_next/static/chunks/fonts/Channel4Horseferry-Regular-8860e6d2e84716284c6b603e77d3a1dd.woff2";